"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
// deps: array of state dependencies that are referenced inside callback. defaults to []
exports.useUsingMouse = function (deps) {
    if (deps === void 0) { deps = []; }
    var _a = __read(react_1.useState(false), 2), usingMouse = _a[0], setUsingMouse = _a[1];
    var onMouseDown = function () { return setUsingMouse(true); };
    var onTabDown = function (e) {
        var isTab = e.key === 'Tab' || e.keyCode === 9;
        if (isTab)
            setUsingMouse(false);
    };
    react_1.useEffect(function () {
        document.body.addEventListener('mousedown', onMouseDown, false);
        document.body.addEventListener('keydown', onTabDown, false);
        return function () {
            document.body.removeEventListener('mousedown', onMouseDown, false);
            document.body.removeEventListener('keydown', onTabDown, false);
        };
    }, deps);
    return [usingMouse, setUsingMouse];
};
